module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Wrench_16"],"path":[{"$":{"d":"M14.72,3.4,11.18,6.94,9.06,4.82,12.6,1.28A4,4,0,0,0,7.48,6.75l-6,6,1.77,1.77,6-6A4,4,0,0,0,14.72,3.4Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Wrench_16.svg
// module id = 2334
// module chunks = 1